import _ from 'lodash'

import { firebaseDb as db } from '../firebase'
import {
  asyncRequest,
  asyncSuccess,
  asyncFail,
  storeProjectsRoles,
  selectProject,
  updateProjectUsersCollection,
  cleanMessages
} from '../actions'
import { Roles } from '../config'

const uuid = require('uuid/v1')

// action types

// action creators
export const fetchProjects = (userId, isSuperAdmin) => {
  return dispatch => {
    dispatch(asyncRequest('fetchProjects'))

    // DO NOT CHANGE PERMISSION LEVEL WITHOUT UPDATING SECURITY RULES ACCORDINGLY - EVEYRHING WILL BREAK!
    let projectsRef = null
    if (isSuperAdmin) {
      // superadmin - fetch all Projects
      projectsRef = db.collection('projects')
    } else {
      // normal user - fetch only Projects I am assigned to
      projectsRef = db.collection('projects').where(`roles.${userId}`, '<=', Roles.PROJECT.SALESPERSON)
    }

    projectsRef
      .get()
      .then(projectsSnap => {
        const projects = {}
        const projectsRoles = {}

        projectsSnap.forEach(doc => {
          projects[doc.id] = doc.data()
          projects[doc.id].id = doc.id

          // get all my Project roles - only if I am not superadmin
          projectsRoles[doc.id] = isSuperAdmin ? 0 : doc.data().roles[userId]
        })
        dispatch(asyncSuccess('fetchProjects', { projects }, null))
        dispatch(storeProjectsRoles(projectsRoles))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('fetchProjects', error.code))
        dispatch(cleanMessages())
      })
  }
}

// get current user & if he is superadmin
export const createProject = (projectDetails, user, closeModalResetFields) => {
  return dispatch => {
    dispatch(asyncRequest('createProject'))

    const projectId = uuid()

    let newProject = {
      ...projectDetails,
      questions: {},
      stats: {},
      usedIntegrations: {
        hubspot: false
        // ...
      }
    }
    if (!user.isSuperAdmin) {
      newProject.roles = { [user.settings.uid]: 10 }
    }

    const projectDoc = db.collection('projects').doc(projectId)
    projectDoc
      .set(newProject)
      .then(() => {
        // create Integrations sub collection (with one document, 'i') to store Integration's tokens
        db.collection('projects').doc(projectId).collection('integrations').doc('i').set({}).then(() => {
          dispatch(
            asyncSuccess(
              'createProject',
              { project: { [projectId]: { id: projectId, ...newProject } }, projectId },
              'Project was successfully created'
            )
          )
          closeModalResetFields()
        })
      })
      .catch(error => {
        dispatch(asyncFail('createProject', error.message))
        dispatch(cleanMessages())
      })
  }
}

export const editProjectGeneral = (projectId, user, fields) => {
  return dispatch => {
    dispatch(asyncRequest('editProjectGeneral'))

    const projectRef = db.collection('projects').doc(projectId)

    projectRef
      .update(fields)
      .then(() => {
        dispatch(
          asyncSuccess('editProjectGeneral', { projectId, fields }, 'project General settings saved successfully')
        )
        dispatch(selectProject(null))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('editProjectGeneral', error.message))
        dispatch(cleanMessages())
      })
  }
}

export const editProjectUsers = (projectId, users, companyUsers) => {
  return dispatch => {
    dispatch(asyncRequest('editProjectUsers'))

    const projectRef = db.collection('projects').doc(projectId)

    if (!users.roles) {
      users.roles = null
    }

    projectRef
      .update({ ..._.omit(users, ['userIds']) })
      .then(() => {
        dispatch(asyncSuccess('editProjectUsers', { projectId, users }, 'project Users saved successfully'))
        dispatch(cleanMessages())
        dispatch(updateProjectUsersCollection(projectId, users, companyUsers))
      })
      .catch(error => {
        dispatch(asyncFail('editProjectUsers', error))
        dispatch(cleanMessages())
      })
  }
}

export const editProjectQuestions = (projectId, questions, updateQuestionsState) => {
  return dispatch => {
    dispatch(asyncRequest('editProjectQuestions'))

    const projectRef = db.collection('projects').doc(projectId)

    projectRef
      .update({ questions })
      .then(() => {
        dispatch(asyncSuccess('editProjectQuestions', { projectId, questions }, 'project Questions saved successfully'))
        dispatch(cleanMessages())
        updateQuestionsState(questions)
      })
      .catch(error => {
        dispatch(asyncFail('editProjectQuestions', error))
        dispatch(cleanMessages())
      })
  }
}

export const editProjectIntegrations = (projectId, integrations) => {
  return dispatch => {
    dispatch(asyncRequest('editProjectIntegrations'))

    const projectIntegrationsRef = db.collection('projects').doc(projectId).collection('integrations').doc('i')

    projectIntegrationsRef
      .update({ integrations })
      .then(() => {
        dispatch(
          asyncSuccess(
            'editProjectIntegrations',
            { projectId, integrations },
            'Project Integrations saved successfully'
          )
        )
        dispatch(cleanMessages())
      })
      .catch(error => {
        dispatch(asyncFail('editProjectIntegrations', error))
        dispatch(cleanMessages())
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/projects.js